import React, { useState, useEffect } from "react";
import "../pages/styles/diary.css";

const MENU_CONFIG = {
    admin: {
        items: [
            { path: "/", label: "Главная", isMain: true },
            { path: "/diary", label: "Дневник" },
            { path: "/diary/analytics", label: "Аналитика" },
            { path: "/diary/calendar", label: "Календарь" },
            { path: "/diary/history", label: "История" },
            { path: "/notifications", label: "Уведомления" },
            { path: "/diary/students", label: "Ученицы" },
        ],
    },
    Sysadmin: {
        items: [
            { path: "/", label: "Главная", isMain: true },
            { path: "/diary", label: "Дневник" },
            { path: "/diary/analytics", label: "Аналитика" },
            { path: "/diary/calendar", label: "Календарь" },
            { path: "/notifications", label: "Уведомления" },
            { path: "/diary/history", label: "История" },
            { path: "/diary/students", label: "Ученицы" },
        ],
    },
    coach: {
        items: [
            { path: "/", label: "Главная", isMain: true },
            { path: "/diary", label: "Дневник" },
            { path: "/diary/calendar", label: "Календарь" },
            { path: "/diary/analytics", label: "Аналитика" },
            { path: "/notifications", label: "Уведомления" },
            { path: "/diary/students", label: "Ученицы" },
            { path: "/diary/history", label: "История" },
        ],
    },
    student: {
        items: [
            { path: "/", label: "Главная", isMain: true },
            { path: "/diary", label: "Дневник" },
            { path: "/diary/calendar", label: "Календарь" },
            { path: "/diary/history", label: "История" },
            { path: "/student-analytics", label: "Аналитика" },
            { path: "/notifications", label: "Уведомления" },
            { path: null, label: "Тренер", dynamicPath: (props) => `/profile/${props.fixedT}` },
            { path: "/rules.pdf", label: "Информация" },
        ],
    },
};

const MenuItem = ({ item, props, isMobile = false, onClose }) => {
    const href = item.dynamicPath ? item.dynamicPath(props) : item.path;
    const isExit = item.label === "Выйти";

    const baseStyle = {
        display: "block",
        padding: isMobile ? "16px 20px" : "12px 16px",
        color: item.isMain ? "#e41655" : isExit ? "#dc2626" : "#374151",
        textDecoration: "none",
        transition: "all 0.2s ease",
        borderRadius: "8px",
        margin: isMobile ? "4px 0" : "2px 0",
        fontSize: isMobile ? "16px" : "14px",
        fontWeight: item.isMain ? "600" : "500",
        border: "none",
        background: "none",
        width: "100%",
        textAlign: "left",
        cursor: "pointer",
        fontFamily: "inherit",
    };

    const handleClick = (e) => {
        if (isExit) {
            e.preventDefault();
            window.location.href = href;
        }
        if (onClose) {
            onClose();
        }
    };

    return (
        <li style={{ listStyle: "none", margin: 0 }}>
            {isExit ? (
                <button
                    style={baseStyle}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
                    onClick={handleClick}
                >
                    {item.label}
                </button>
            ) : (
                <a
                    href={href}
                    style={baseStyle}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
                    onClick={onClose}
                >
                    {item.label}
                </a>
            )}
        </li>
    );
};

const MobileMenu = ({ isOpen, onClose, menuItems, props }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }

        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const profileHref = `/profile/${localStorage.getItem("clid")}`;
    const exitHref = "/exit_session";
    const allMenuItems = [...menuItems, { label: "Профиль", path: profileHref }, { label: "Выйти", path: exitHref, isExit: true }];

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1000,
                display: "flex",
            }}
        >
            <div
                style={{
                    width: "280px",
                    backgroundColor: "white",
                    height: "100%",
                    padding: "20px 0",
                    boxShadow: "2px 0 8px rgba(0,0,0,0.1)",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <div style={{ padding: "0 20px 16px 20px", borderBottom: "1px solid #e5e7eb", marginBottom: "16px" }}>
                    <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#1a1a1a" }}>Меню</h3>
                </div>

                <ul style={{ margin: 0, padding: "0 12px", flex: 1 }}>
                    {allMenuItems.map((item, index) => (
                        <MenuItem key={index} item={item} props={props} isMobile={true} onClose={onClose} />
                    ))}
                </ul>
            </div>

            <div style={{ flex: 1 }} onClick={onClose} />
        </div>
    );
};

const DesktopSidebar = ({ menuItems, props }) => {
    const profileHref = `/profile/${localStorage.getItem("clid")}`;
    const exitHref = "/exit_session";
    const allMenuItems = [...menuItems, { label: "Профиль", path: profileHref }, { label: "Выйти", path: exitHref, isExit: true }];

    return (
        <div
            style={{
                position: "fixed",
                left: 0,
                top: 0,
                bottom: 0,
                width: "240px",
                backgroundColor: "white",
                borderRight: "1px solid #e5e7eb",
                padding: "20px 0",
                overflowY: "auto",
                zIndex: 40,
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            }}
        >
            <div style={{ padding: "0 20px 20px 20px", borderBottom: "1px solid #e5e7eb", marginBottom: "16px" }}>
                <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#1a1a1a" }}>Навигация</h3>
            </div>

            <div style={{ display: "flex", flexDirection: "column", height: "90%" }}>
                <div style={{ flex: 1, padding: "0 12px" }}>
                    <ul style={{ margin: 0, padding: 0 }}>
                        {allMenuItems.map((item, index) => (
                            <MenuItem key={index} item={item} props={props} />
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default function Navbar(props) {
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1450);
    const userType = props.usertype || "student";
    const menuConfig = MENU_CONFIG[userType] || MENU_CONFIG.student;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1450);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setMobileMenuOpen(false)} menuItems={menuConfig.items} props={props} />
            {isMobile && (
                <button
                    onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                    style={{
                        position: "fixed",
                        top: "16px",
                        left: "16px",
                        zIndex: 50,
                        background: "white",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        padding: "10px",
                        cursor: "pointer",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#f9fafb")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "white")}
                >
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="1" viewBox="0 0 24 24" height="25px" width="25px" xmlns="http://www.w3.org/2000/svg"><g id="Menu_Burger"><path d="M3.563,4.063c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l16.874,-0.001c0.276,-0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-16.874,0.001Z" /><path d="M3.563,12.501c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l16.874,-0.002c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-16.874,0.002Z" /><path d="M3.563,20.939c-0.276,-0 -0.5,-0.224 -0.5,-0.5c-0,-0.276 0.224,-0.5 0.5,-0.5l16.874,-0.002c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5l-16.874,0.002Z" /></g></svg>
                </button>
            )}

            {!isMobile && <DesktopSidebar menuItems={menuConfig.items} props={props} />}
            {!isMobile && <div style={{ marginLeft: "240px" }} />}
        </>
    );
}
